import React, { useState, useCallback } from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { STATEMENT_KEYS } from '../../utils/translation-constants'
import UserIcon from 'custom/assets/common-icons/User.svg'
import NumberFormat from 'react-number-format'
import { getCurrentAccDetailsSelector } from '../../store/selectors/app.selector'
import { useSelector } from 'react-redux'
import PortfolioService from '../../services/portfolio.service'
import { NeoLoader } from '../../components/FormComponents'
import DownloadIcon from 'custom/assets/common-icons/Download.svg'
import config from 'custom/config/environment'

export default function StatementCard({ dataSource = [], fromDate, toDate }) {
  const [expanded, setExpanded] = useState(null)
  const { t } = useTranslation()
  const accountDetails = useSelector(getCurrentAccDetailsSelector) || {}
  const [downloadLoader, setDownloadLoader] = useState(false)

  const downloadStatement = useCallback(
    async (data) => {
      try {
        setDownloadLoader(true)
        const reqParams = {
          accountNo: accountDetails.accountNo,
          brnCode: accountDetails.brnCode,
          fromDate: fromDate,
          toDate: toDate,
          format: data.value,
        }
        await PortfolioService.getPDFFullStatement(reqParams)
        setDownloadLoader(false)
      } catch (err) {
        setDownloadLoader(false)
        console.log(err)
      }
    },
    [accountDetails],
  )

  return (
    <>
      <div className='d-flex justify-content-between align-items-center pt-4'>
        <div className='statement-list-title font-weight-bold col-6'>
          {new Date(fromDate).toLocaleString('default', {
            month: 'long',
          })}
          {new Date(fromDate).getMonth() != new Date(toDate).getMonth() &&
            `-${new Date(toDate).toLocaleString('default', {
              month: 'long',
            })}`}
          {' ' + t(STATEMENT_KEYS.HEADER)}
        </div>

        <div className='col-4 mr-2 p-0 text-right'>
          <div id='dropdown' style={{ position: 'relative' }}>
            <button
              type='button'
              className='btn p-2 detailed-statement-btn d-flex justify-content-around'
              style={{ fontSize: 10, outline: 'none' }}>
              <img src={DownloadIcon} alt='' className='mr-2' height={23} width={20} />
              <span className='font-weight-bold'>
                {downloadLoader ? (
                  <NeoLoader width={'10px'} height={'10px'} text={t(STATEMENT_KEYS.DOWNLOADING)} />
                ) : (
                  t(STATEMENT_KEYS.DOWNLOAD_STATEMENT)
                )}
              </span>
            </button>
            <div className='dropdown-content'>
              {config.FORMAT_LIST.map((option, index) => (
                <div onClick={() => downloadStatement(option)} key={index} value={option.value}>
                  {option.title}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {dataSource.length === 0 && (
        <div className='text-center'>{t(STATEMENT_KEYS.NO_TRANSACTION)}</div>
      )}

      {dataSource.length > 0 && (
        <>
          {dataSource.map((statement, i) => (
            <div key={i} className='statement-item'>
              <div
                className='d-flex justify-content-between font-weight-600'
                onClick={() => (expanded == i ? setExpanded(null) : setExpanded(i))}>
                <div className='d-flex'>
                  <div className='mr-3'>
                    <img src={UserIcon} alt='user icon' className='user-icon p-2' />
                  </div>
                  <div>
                    <div className='statement-desc'>{statement.txnTypeDes}</div>
                    <div className='statement-date-time'>
                      {statement['date'] !== null ? statement['date'] : '-'}
                    </div>
                  </div>
                </div>
                <div className='text-right'>
                  <div>
                    <span className='statement-currency mr-1'>{statement.txncurrency}</span>
                    <span className='statement-amount'>
                      <NumberFormat
                        value={statement.amount}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={''}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        allowEmptyFormatting
                      />
                    </span>
                    {/* {statement.debitOrCredit == 'Debit' ? (
                  <img src={SpendIcon} alt='' />
                ) : (
                  <img src={CreditIcon} alt='' style={{ transform: 'rotateZ(180deg)' }} />
                )} */}
                  </div>
                  <div className='statement-date-time'>
                    {/* {new Date().getHours() + ':' + new Date().getMinutes()} */}
                  </div>
                </div>
              </div>
              {expanded == i && (
                <div className='ml-2 mt-3'>
                  <div className='row my-2'>
                    <div className='col-4'>
                      <div className='statement-expanded-label font-weight-500'>
                        {t(STATEMENT_KEYS.REF_NO)}
                      </div>
                      <div className='statement-expanded-value font-weight-bold'>
                        {statement?.referenceNumber || statement?.slNo}
                      </div>
                    </div>
                    <div className='col-4'>
                      <div className='statement-expanded-label font-weight-500'>
                        {t(STATEMENT_KEYS.CURRENCY)}
                      </div>
                      <div className='statement-expanded-value font-weight-bold'>
                        {statement.txncurrency}
                      </div>
                    </div>
                    <div className='col-4'>
                      <div className='statement-expanded-label font-weight-500'>
                        {t(STATEMENT_KEYS.AMOUNT)}
                      </div>
                      <div className='statement-expanded-value font-weight-bold'>
                        <NumberFormat
                          value={statement.amount}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={''}
                          fixedDecimalScale={true}
                          decimalScale={2}
                          allowEmptyFormatting
                        />
                      </div>
                    </div>
                  </div>
                  <div className='row my-2'>
                    <div className='col-4'>
                      <div className='statement-expanded-label font-weight-500'>
                        {t(STATEMENT_KEYS.TXN_TYPE_DESC)}
                      </div>
                      <div className='statement-expanded-value font-weight-bold'>
                        {statement.txnTypeDes}
                      </div>
                    </div>
                    <div className='col-4'>
                      <div className='statement-expanded-label font-weight-500'>
                        {t(STATEMENT_KEYS.TRANSACTION_DATE)}
                      </div>
                      <div className='statement-expanded-value font-weight-bold'>
                        {statement['date'] !== null ? statement['date'] : '-'}
                      </div>
                    </div>
                    <div className='col-4'>
                      <div className='statement-expanded-label font-weight-500'>
                        {t(STATEMENT_KEYS.DEBIT_CREDIT)}
                      </div>
                      <div className='statement-expanded-value font-weight-bold'>
                        {statement.debitOrCredit}
                      </div>
                    </div>
                  </div>
                  <div className='row my-2'>
                    <div className='col-12'>
                      <div className='statement-expanded-label font-weight-500'>
                        {t(STATEMENT_KEYS.REMARKS)}
                      </div>
                      <div className='statement-expanded-value font-weight-bold'>
                        {statement.remarks || '-'}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </>
      )}
    </>
  )
}
